import React, { useState, useEffect } from "react";
import { InputGroup } from "react-bootstrap";
import NumericalInput from "../NumericalInput";
import { formatFloat } from "../../utils/format";
import './index.scss';

interface InputAmountProps {
  val: number;
  setVal(input: number): void;
  suffix: string;
  maxTitle: string;
  max: number;
  min?: number;
}

let updateIncremental = 0;

export default function InputAmount({val, setVal, suffix, maxTitle, max, min}: InputAmountProps) {
  const [stringVal, setStringVal] = useState<string>(val.toString());
  const onUserInput = (input: string) => setValDelayed(input);
  const onMax = () => setValDelayed(formatFloat(max, 9).toString());
  const step = max ? Math.pow(10, Math.floor(Math.log10(max)) - 8) : 0;
  min = min ? min : 0;

  function setValDelayed(newValString: string) {
    setStringVal(newValString);
    const newVal = parseFloat(newValString);
    const currentUpdate = ++updateIncremental;
    if (currentUpdate % 50 === 0) setVal(newVal);
    else {
      setTimeout(() => {
        if (currentUpdate === updateIncremental) {
          setVal(newVal);
        }
      }, 10);
    }
  }

  return (<>
    <div className="input-amount">
      <InputGroup className="available">
        {maxTitle}: {formatFloat(max, 9)} {suffix}
      </InputGroup>
      <InputGroup className="input-container mb-3">
        <InputGroup.Prepend className="max-input">
          <button onClick={onMax}>MAX</button>
        </InputGroup.Prepend>
        <NumericalInput value={stringVal} onUserInput={input => {onUserInput(input)}} />
        <InputGroup.Append className="suffix">
          <span>{suffix}</span>
        </InputGroup.Append>
      </InputGroup>
    </div>
    <input 
      type="range" 
      className="form-range" 
      value={stringVal}
      step={step} 
      min={step ? min - min % step + step : 0}
      max={step ? max - max % step : 0}
      onChange={(event) => setValDelayed(event.target.value)} 
    />
  </>);
}

interface InputAmountMiniProps {
  val: number;
  setVal(input: number): void;
  suffix: string;
}

export function InputAmountMini({val, setVal, suffix}: InputAmountMiniProps) {
  const [stringVal, setStringVal] = useState<string>(val.toString());
  const onUserInput = (input: string) => setStringVal(input);
  useEffect(() => {
    const newVal = stringVal ? parseFloat(stringVal) : 0;
    if (val === newVal) return; // avoid infinite loop
    setVal(newVal);
  }, [stringVal]);
  useEffect(() => {
    const newStringVal = formatFloat(val);
    if (stringVal === newStringVal) return; // avoid infinite loop
    setStringVal(newStringVal);
  }, [val]);

  return (
    <div className="input-amount-mini">
      <InputGroup className="input-container">
        <NumericalInput value={stringVal} onUserInput={input => {onUserInput(input)}} />
        <InputGroup.Append className="suffix">
          <span>{suffix}</span>
        </InputGroup.Append>
      </InputGroup>
    </div>
  );
}